import { lazy } from "react";
import { BrowserRouter, Routes, Route, useParams } from 'react-router-dom'
import LayoutPublic from "./Layout";


/*
import Home  from "../containers/Home"
import CustomizeYourTrip  from "../containers/CustomizeYourTrip"
import VacationPackage  from "../containers/VacationPackage"
import VacationPackages  from "../containers/VacationPackages"
import Enquiry  from "../containers/Enquiry"
*/
const Home = lazy(() => import("../containers/Home.jsx"))
const CustomizeYourTrip = lazy(() => import("../containers/CustomizeYourTrip.jsx"))
const VacationPackage = lazy(() => import("../containers/VacationPackage.jsx"))
const VacationPackages = lazy(() => import("../containers/VacationPackages.jsx"))
const Enquiry = lazy(() => import("../containers/Enquiry.jsx"))
/*
const ContactUs = lazy(() => import("../containers/ContactUs"))
const Bookings = lazy(() => import("../containers/Bookings"))
const Login = lazy(() => import("../containers/Login"))
*/
const App = () => {
	const params =useParams()
	console.log(params)
	console.log("APP")
	return <main className="main-container">
		<BrowserRouter>
			<Routes>
				<Route path="/" element={<LayoutPublic />}>
					<Route index element={<Home />} />
					<Route path="/vacation-packages" element={<VacationPackages />} />
					<Route
						path="vacation-packages-santa-teresa"
						element={<VacationPackages />}
					/>
					<Route path="vacation-packages/:pack_slug" element={<VacationPackage />} />
					<Route path="/vacation-packages-santa-teresa/:pack_slug" element={<VacationPackage />}/>
					<Route path="customize-your-trip" element={<CustomizeYourTrip />} />
					<Route path="/holidays-in-santa-teresa"  element={<CustomizeYourTrip />}  />
					<Route
						path="/customize-your-trip/:checkIn/:checkOut/:guests"
						element={<CustomizeYourTrip />} 
					/>
					<Route
						path="/holidays-in-santa-teresa/:checkIn/:checkOut/:guests"
						element={<CustomizeYourTrip />} 
					/>
					<Route path="/enquiry" element={<Enquiry />}/>
					<Route path="/booking" element={<Enquiry />}/>
				</Route>
				<Route path="/*" element={<VacationPackages />} />
			</Routes>
		</BrowserRouter>
	</main>
}

/*
<Route path="/vacation-packages" element={<VacationPackages />} />
					<Route
						path="/vacation-packages-santa-teresa"
						element={<VacationPackages />}
					/>
					<Route path="/vacation-packages/:pack_slug" element={<VacationPackage />} />
					<Route
						path="/vacation-packages-santa-teresa/:pack_slug"
						element={<VacationPackage />}
					/>
					<Route path="/customize-your-trip" element={<CustomizeYourTrip />} />
					<Route path="/holidays-in-santa-teresa" element={<CustomizeYourTrip />} />
					<Route
						path="/customize-your-trip/:checkIn/:checkOut/:guests"
						element={<CustomizeYourTrip />}
					/>
					<Route
						path="/holidays-in-santa-teresa/:checkIn/:checkOut/:guests"
						element={<CustomizeYourTrip />}
					/>
					<Route path="/inquiry" element={<Enquiry />} />
					<Route path="/enquiry" element={<Enquiry />} />
					<Route path="/booking" element={<Enquiry />} />
					<Route path="/contact-us" element={<ContactUs />} />
					<Route path="/bookings-admin" element={<Bookings />} />
					<Route path="/bookings-admin/login" element={<Login />} />

					<Route path="/*" element={<VacationPackages />} />
					
					<Route path="/vacation-packages" element={<VacationPackages />} />
					<Route
						path="/vacation-packages-santa-teresa"
						element={<VacationPackages />}
					/>
					<Route path="/vacation-packages/:pack_slug" element={<VacationPackage />} />
					<Route
						path="/vacation-packages-santa-teresa/:pack_slug"
						element={<VacationPackage />}
					/>
					<Route path="/customize-your-trip" element={<CustomizeYourTrip />} />
					<Route path="/holidays-in-santa-teresa" element={<CustomizeYourTrip />} />
					<Route
						path="/customize-your-trip/:checkIn/:checkOut/:guests"
						element={<CustomizeYourTrip />}
					/>
					<Route
						path="/holidays-in-santa-teresa/:checkIn/:checkOut/:guests"
						element={<CustomizeYourTrip />}
					/>
					<Route path="/inquiry" element={<Enquiry />} />
					<Route path="/enquiry" element={<Enquiry />} />
					<Route path="/booking" element={<Enquiry />} />
					<Route path="/contact-us" element={<ContactUs />} />
					<Route path="/bookings-admin" element={<Bookings />} />
					<Route path="/bookings-admin/login" element={<Login />} />
					<Route path="/*" element={<VacationPackages />} />
*/

export default App